export const TabKey = {
  STAGE_ONE: 'stage1',
  STAGE_TWO: 'stage2'
} as const;
export type TabKeyType = (typeof TabKey)[keyof typeof TabKey];

export const NAVS: { label: string; key: TabKeyType }[] = [
  { label: 'Stage One', key: TabKey.STAGE_ONE },
  { label: 'Stage Two', key: TabKey.STAGE_TWO }
];

export const DEFAULT_BRANCH = 'v4';

export interface StageOnePoint {
  time: number;
  moving_average: number;
}

// Values come straight from the stage one CSV, so the numeric fields arrive as strings. The two
// ratios are computed, and serialize to null when they come out NaN or Infinity.
export interface AdRawEffectStatistics {
  min: string;
  max: string;
  mean: string;
  median: string;
  stdev: string;
  kurtosis: string;
  minMedianStDev: number | null;
  maxMedianStDev: number | null;
  startDate: string;
  endDate: string;
}

export interface StageOneData {
  allValues?: StageOnePoint[];
  adRawEffectStatistics: AdRawEffectStatistics;
  percentile1: number;
  percentile99: number;
  // Undefined when the impulse response PDF is missing for this KPI and branch.
  pdf?: Blob;
}

export const SpotLength = {
  FIFTEEN: '15',
  THIRTY: '30'
} as const;
export type SpotLengthType = (typeof SpotLength)[keyof typeof SpotLength];
export const SPOT_LENGTHS: SpotLengthType[] = [SpotLength.FIFTEEN, SpotLength.THIRTY];

// Metrics are null when the lambda's average comes out NaN, which JSON serializes as null.
interface StageTwoLengthEntry {
  ad_raw_effect?: number | null;
  adeffect_per_dollar?: number | null;
  stageTwoAvg?: number | null;
  stageTwoByCreative?: Record<string, number | null>;
}

export interface StageTwoRow extends Partial<Record<SpotLengthType, StageTwoLengthEntry>> {
  network: string;
  avail: string;
  rotation_id: string;
  rotation_name: string;
}

// A stage two metric path below a spot length, e.g. ['stageTwoByCreative', 'MyCreative'].
export type StageTwoPath =
  ['ad_raw_effect' | 'adeffect_per_dollar' | 'stageTwoAvg'] | ['stageTwoByCreative', string];

export interface StageTwoData {
  rows: StageTwoRow[];
  creatives: string[];
  stageTwoFileTimeStamp: string;
}

export const STAGE_ONE_RAW_EFFECT = 'Stage One AdRawEffect';
export const STAGE_ONE_PER_DOLLAR = 'Stage One AdEffect Per Dollar';
export const STAGE_TWO_PER_DOLLAR = 'Stage Two AdEffect Per Dollar';
